module.exports = __webpack_public_path__ + "img/document.d27862d0.svg";